import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah Chen',
    role: 'Botanical Print Artist',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    rating: 5,
    text: 'My Etsy sales doubled after switching to Artreal mockups. Buyers love seeing my prints in real rooms instead of generic white backgrounds.'
  }, {
    name: 'Marcus Rivera',
    role: 'Abstract Artist',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marcus',
    rating: 5,
    text: 'The Studio feature is a game-changer. I can generate mockups for my entire collection in minutes. Saved me literally hours every week.'
  }, {
    name: 'Emma Thompson',
    role: 'Vintage Poster Shop',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Emma',
    rating: 5,
    text: 'The AI-generated Etsy descriptions are surprisingly good. I barely have to edit them. This app pays for itself in time saved alone.'
  }];
  return <section className="w-full bg-gradient-to-b from-[#0A0A0F] to-[#1A1A2E] py-24 lg:py-32" data-id="element-125">
      <div className="max-w-7xl mx-auto px-6" data-id="element-126">
        <div className="text-center mb-16" data-id="element-127">
          <span className="text-sm font-bold text-[#3B9EFF] tracking-widest uppercase" data-id="element-128">
            Testimonials
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-4 leading-tight tracking-tight" data-id="element-129">
            Loved by artists worldwide
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-130">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-300" data-id="element-131">
              <div className="flex gap-1 mb-6" data-id="element-132">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#F5C842] text-[#F5C842]" data-id="element-133" />)}
              </div>

              <p className="text-gray-300 leading-relaxed mb-8" data-id="element-134">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-135">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full bg-gradient-to-br from-[#3B9EFF] to-[#F5C842]" data-id="element-136" />
                <div data-id="element-137">
                  <div className="font-bold text-white" data-id="element-138">{testimonial.name}</div>
                  <div className="text-sm text-gray-400" data-id="element-139">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}